import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import pos1_freq500 from "./components/pos-1-freq-500";
import pos1_freq650 from "./components/pos-1-freq-650";
import pos1_freq900 from "./components/pos-1-freq-900";
import pos1_freq1400 from "./components/pos-1-freq-1400";
import pos2_freq500 from "./components/pos-2-freq-500";
import pos2_freq650 from "./components/pos-2-freq-650";
import pos2_freq900 from "./components/pos-2-freq-900";
import pos2_freq1400 from "./components/pos-2-freq-1400";
import pos3_freq500 from "./components/pos-3-freq-500";
import pos3_freq650 from "./components/pos-3-freq-650";
import pos3_freq900 from "./components/pos-3-freq-900";
import pos3_freq1400 from "./components/pos-3-freq-1400";
import pos4_freq500 from "./components/pos-4-freq-500";
import pos4_freq650 from "./components/pos-4-freq-650";
import pos4_freq900 from "./components/pos-4-freq-900";
import pos4_freq1400 from "./components/pos-4-freq-1400";

const principle: Slide = {
  description:
    "Exciting a single and specific resonance in a cavity turns out to be more complicated than it seems! Not only the frequency of the excitation should match that of the resonance, but the generated pressure field should match the pressure distribution of the targeted cavity resonance. When the source is restricted to be a point source located on one of the face of the cavity, exciting a unique resonance is not an easy task, as you will see here while changing the frequency and/or moving the point source. A particular attention should be paid to the following cases: (ii) when the source is at the correct frequency and at a pressure antinode of the mode, (ii) when the source is at the correct frequency but at a pressure node of the mode, (iii) when the source is off any resonance frequency.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {
            label: "Excitation frequency",
            labelPosition: "top",
          },
          items: [{ name: "500 Hz" }, { name: "650 Hz" }, { name: "900 Hz" }, { name: "1400 Hz" }],
        },
        {
          type: "button",
          options: {
            label: "Source position",
            labelPosition: "top",
          },
          items: [{ name: "1" }, { name: "2" }, { name: "3" }, { name: "4" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], []],
      components: [
        [pos1_freq500, pos2_freq500, pos3_freq500, pos4_freq500],
        [pos1_freq650, pos2_freq650, pos3_freq650, pos4_freq650],
        [pos1_freq900, pos2_freq900, pos3_freq900, pos4_freq900],
        [pos1_freq1400, pos2_freq1400, pos3_freq1400, pos4_freq1400],
      ],
    },
  },
};

export default principle;
